const ColorSchemeCode = {
    'text'          : '#333333',
    'subText'       : '#4f4f4f',
    'actionBtn'     : '#716B67',
    'signupBtn'     : '#56CCF2',
    'activeNav'     : '#716B67',
    'inactiveNav'   : '#BDBDBD',
    'activeTab'     : '#1274E0',
    'inactiveTab'   : '#828282',
    'label'         : '#828282',
    'paragraph'     : '#828282',
    'white'         : '#ffffff'
}

export {
    ColorSchemeCode
}